import React from "react";
import { FALLBACK_CHF_TO_EUR_RATE } from "../../../constants/pricing";
import { exchangeRateSessionSlice, useEphemeralSelector } from "../../../store/ephemeral";

interface PriceConversionProps {
    "price":           number | null;
    "className"?:      string;
    "compact"?:        boolean;
    "chooseEuro":      boolean;
    "showFromPrefix"?: boolean;
}

const PriceConversion: React.FC<PriceConversionProps> = ( {
    price,
    className = "",
    compact = false,
    chooseEuro,
    showFromPrefix = false,
} ) => {
    const chfToEurRate = useEphemeralSelector( exchangeRateSessionSlice, ( session ) => session.chfToEurRate );
    const exchangeRate = chfToEurRate !== null && chfToEurRate > 0 ? chfToEurRate : FALLBACK_CHF_TO_EUR_RATE;

    if ( price === null || price === undefined ) {
        return (
            <div className={`inline-flex items-center ${ className }`}>
                <span className="text-primary">
                    N/A
                </span>
            </div>
        );
    }

    const convertedPrice = chooseEuro ? price * exchangeRate : price;

    const formattedPrice = `${ convertedPrice.toFixed( 2 ) } ${ chooseEuro ? "€" : "CHF" }`;

    return (
        <span
            className={`font-bold ${ compact ? "text-xs" : "text-sm" } ${ className }`}
        >
            {showFromPrefix === true
                ? (
                    <>
                        dès
                        {" "}
                    </>
                )
                : null}
            {formattedPrice}
        </span>
    );
};

export default PriceConversion;
